<template>

    <div class="lg:flex gap-4 mt-10">
        <div class="flex-1">
            <div v-for="( address, index ) in addresses" :key="index">
                <div class="text-gray-500">
                    <p class="font-poppins font-semibold text-lg">
                        <font-awesome-icon icon="fa-location-dot" class="mr-2" />
                        {{ address.street }}, {{ address.number }}. {{ address.neighborhood }}, {{ address.city }}, {{ address.state_label }}
                    </p>
        
                    <p class="font-poppins font-normal text-base mt-2 lg:ml-6">Consultório particular</p>
                    <a href="#" class="text-xs underline lg:ml-6">Detalhes da localização</a>
                </div>
                
                <p class="font-poppins my-10 text-gray-500 font-normal text-base">
                    <font-awesome-icon icon="fa-phone" class="mr-2" />
                    {{ address.phone }}
                </p>
            </div>
        </div>

        <div class="mt-10 text-gray-500 lg:mt-0 flex-1">
            <p class="font-poppins font-normal text-base capitalize">
                <font-awesome-icon icon="fa-calendar-day" class="mr-2" />
                Próxima data: {{ nextDateString }}
            </p>
    
            <button 
                type="button" 
                class="w-40 h-10 bg-none border border-primary rounded-full text-primary text-sm mt-1 lg:ml-6"
                @click="$emit( 'viewSchendule' )">
                    Mostrar agenda
                    <font-awesome-icon icon="fa-chevron-right" />
            </button>
        </div>
    </div>


    <p class="font-poppins mt-10 text-gray-500 font-semibold text-lg">
        <font-awesome-icon icon="fa-landmark" class="mr-2" />
        Diplomas
    </p>

    <ul class="my-10 flex flex-wrap gap-4">
        <li v-for="(certificate, index) in certificates" :key="certificate.id">
            <div :class="{
                'absolute z-40 top-0 left-0 bottom-0 w-full bg-gray-800/50 flex items-center justify-center flex-col': index == openIndex,
                'relative w-[217px] h-[165px]': index != openIndex,
            }">
                <button class="w-10 h-10 absolute top-10 right-10 text-white" @click="openIndex = null" v-show="index == openIndex">
                    <font-awesome-icon icon="fa-x" />
                </button>

                <img :src="certificate.url" class="w-full max-w-[600px]" @click="openIndex = index" />

                <p class="text-xs font-poppins mt-3 text-primary text-center">
                    {{ certificate.name }}
                </p>
            </div>

        </li>
    </ul>

</template>

<script>

export default {

    emits: [ 'viewSchendule' ],

    props: {
        addresses: {
            type: Object,
            required: true,
        },

        nextDate: {
            type: String,
            required: true,
        },

        certificates: {
            type: Array,
            required: true,
        }
    },


    data() {
        return {
            openIndex: null,
        }
    },


    computed: {
        nextDateString: function() {
            if ( !this.$props.nextDate )
                return 'Sem agenda cadastrada'

            const date = new Date( this.$props.nextDate )
            return `${ date.toLocaleDateString( 'pt-BR', { weekday: 'long' } ) } ${ date.getDate() } ${ date.toLocaleDateString( 'pt-BR', { month: 'long' } ) }`
        }
    }
}

</script>
